<template>
  <div class="mask-confirm">
    <div class="confirm-box">
      <div class="confirm-content font-85">{{confirm_txt}}</div>
      <div class="confirm-footer">
        <div class="confirm-success font-85" @click="handleSuccess">{{success_txt}}</div>
        <div class="confirm-cancel" @click="handleCancel">{{cancel_txt}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    confirm_txt: {
      type: String,
      default: "是否删除？",
    },
    success_txt: {
      type: String,
      default: "是",
    },
    cancel_txt: {
      type: String,
      default: "否",
    },
  },
  data() {
    return {};
  },
  methods: {
    handleSuccess() {
      this.$emit("handleConfirm", true);
    },
    handleCancel() {
      this.$emit("handleConfirm", false);
    },
  },
};
</script>
<style lang="css" scoped>
.mask-confirm {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.45);
}
.confirm-box {
  width: 14.5rem;
  height: 7.8rem;
  position: fixed;
  top: calc(50vh - 6rem);
  left: 2.1rem;
  border-radius: 0.4rem;
  overflow: hidden;
  background: #fff;
  z-index: 100;
}
.confirm-content {
  width: 100%;
  height: 5.4rem;
  padding: 2.2rem 0 2rem;
  text-align: center;
  line-height: 1.2rem;
  font-size: 0.8rem;
}
.confirm-footer {
  width: 100%;
  height: 2.4rem;
  border-top: 0.05rem solid #FAFAFA;
}
.confirm-success,
.confirm-cancel {
  width: 50%;
  height: 2.4rem;
  line-height: 2.4rem;
  font-size: 0.8rem;
  text-align: center;
  float: left;
}
.confirm-cancel {
  color: rgba(24, 144, 255, 1);
  border-left: 0.05rem solid #FAFAFA;
}
</style>


// WEBPACK FOOTER //
// src/pages/confirm.vue